export default __webpack_public_path__ + "245b5605f7497577ea8ea7411d505cf9.jpg";